import { Component, ComponentRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { filter, takeUntil } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';
import { NgxsModule } from '@ngxs/store';
import { NavigationStart, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { IconButtonV2Component } from '../../../shared/components/templates-components-v2/icon-button-v2/icon-button-v2.component';

const defaultHandler: string[] = ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch'];

@Component({
  selector: 'app-popup-base-v2',
  templateUrl: './popup-base-v2.component.html',
  styleUrls: ['./popup-base-v2.component.scss'],
  imports: [CommonModule, RouterModule, NgxsModule, NgScrollbarModule, IconButtonV2Component],
})
export class PopupBaseV2Component implements OnInit, OnDestroy {
  @Input() popupComponent: ComponentRef<any>;
  @Input() popupData: any;
  @Input() title: string;
  @Input() subscribers: string[];
  @Input() popupBodyClass: string;
  @Input() isHeightFull: boolean;
  @Input() hideIcon: boolean;
  @Input() hideCloseBtn: boolean;
  @Input() preventBgClick: boolean;
  @Input() isReadLatterConfirm = null;
  @Input() popupIsImage: boolean;
  @Input() uid: number;
  @Output() close = new EventEmitter();
  @ViewChild('popupContainer', { read: ViewContainerRef, static: true }) popupContainer: ViewContainerRef;
  popupSaveState: any;
  config = {
    handlers: defaultHandler,
    wheelPropagation: true,
  };
  instance: any = {};
  private destroy$: ReplaySubject<void> = new ReplaySubject<void>(1);

  constructor(private router: Router) {
    this.clickPopState();
  }

  @HostListener('click', ['$event'])
  onOuterClick(event): void {
    if (event.target.tagName.toLowerCase() === 'app-popup-base-v2' && !this.preventBgClick) {
      this.onClose();
    }
  }

  ngOnInit(): void {
    if (this.popupContainer) {
      this.popupContainer.clear();
    }
    this.instance = this.popupContainer.createComponent(this.popupComponent as any).instance;
    if (this.popupData) {
      Object.keys(this.popupData || {}).forEach(key => {
        this.instance[key] = this.popupData[key];
      });
    }
    if (this.subscribers) {
      this.popupSaveState = {};
      this.subscribers.forEach(subscriber => {
        this.instance[subscriber].pipe(takeUntil(this.destroy$)).subscribe(data => (this.popupSaveState[subscriber] = data));
      });
    }
    if (this.instance.saveState) {
      this.instance.saveState.subscribe(data => {
        this.popupSaveState = data;
      });
    }
    if (this.instance.closed) {
      this.instance.closed.subscribe(data => {
        this.onClose(data);
      });
    }

    this.popupData?.scrollUpdate$?.pipe(takeUntil(this.destroy$)).subscribe((flag: boolean) => {
      this.config = {
        ...this.config,
        handlers: flag ? [] : defaultHandler,
      };
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.popupContainer.clear();
  }

  onClose(data?): void {
    this.destroy$.next();
    this.instance['isConfirm'] = false;
    this.close.emit({ data, saveState: this.popupSaveState, uid: this.uid });
  }

  private clickPopState(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationStart),
        takeUntil(this.destroy$),
      )
      .subscribe((event: NavigationStart) => {
        if (event.navigationTrigger === 'popstate') {
          this.onClose();
        }
      });
  }
}
